/**
* author     : wangshaobin
* createTime : 2018-07-19
* description:
*/
<style scoped>
  #app{
    height:100%;
  }
  .egBody{
    height:100%;
    min-width: 1080px;
  }
  .egBody{
    display: flex;
    flex-direction: column;
  }
  .egBody_top{
    height:80px;
    background-color: #00e1b2;
  }
  .egBody_bottom{
    display: flex;
    bottom:0;
    left:0;
    right:0;
    position: absolute;
    top:80px;
    min-width:1080px
  }
  .right{
    margin: 10px;
    width: 100%;
    overflow: hidden;
  }
</style>

<template>
  <div id="app" v-loading.fullscreen.lock="this.$store.state.fullscreenLoading">
    <div v-if="!this.$store.state.loginStatus" style="height: 100%;">
      <router-view/>
    </div>
    <div class="egBody" v-else>
      <div class="egBody_top">
        <eghead></eghead>
      </div>
      <div class="egBody_bottom">
        <div class="right">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import eghead from './components/frame/eghead';
  import common from '../static/common'
  import Watermark from './watermark'
  export default {
    name: 'App',
    props: [],
    components: {
      eghead

    },
    computed:{
    },
    data(){
      return {}
    },
    beforeCreate(){

    },
    created(){
      if(JSON.parse(window.sessionStorage.getItem(common.appKey()))){
        this.$store.state.loginStatus = true;
      }else{
        this.$store.state.loginStatus = false;
      }
    },
    beforeMount(){

    },
    mounted(){
        console.log(location.hash)
        let name = location.hash ||'';
        let names = name.split("?")
        if( name!='#/login' &&name!='' &&names[0]!='#/login'){
          this.$store.state.watermarkStatus = true;
          Watermark.set(this.$store.state.sessionUser.name,this);
        }
    },
    methods: {},
    beforeUpdate(){

    },
    updated(){
    },
    beforeDestroy(){

    },
    destroyed(){

    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue